"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'forums-uou' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign({}, defaultConfig, restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams) {
                return _this.bi.log(logParams);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 69 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'forums-uou' });
    }
    ;
    /**
    * @typedef {Object} editPostImageStartUploadingParams
    * @property {GUID} app_id - null
    * @property {GUID} app_site_id - null
    * @property {GUID} instance_id - null
    * @property {string} member_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - image type - cover, avatar, post editor
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: edit post -> Image start uploading. Evid: 551.
     * Event description: event triggered when a user start to upload Image (comes together with Image finish uploading for success rate).
    
     * app_id - Type: guid.
     *
     * app_site_id - Type: guid.
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: image type - cover, avatar, post editor
     *
     * visitor_id - Type: guid.
     * @param {editPostImageStartUploadingParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editPostImageStartUploading = function (params) {
        return this.bi.log(__assign({ evid: 551 }, params));
    };
    /**
    * @typedef {Object} forumPostsSortParams
    * @property {GUID} app_id - null
    * @property {GUID} app_site_id - app site id
    * @property {GUID} instance_id - null
    * @property {string} member_id - memeber id
    * @property {GUID} biToken - msid
    * @property {string} sort_by - newest, oldest, number of comments, number of views or number of likes
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Forum posts - sort. Evid: 563.
     * Event description: Event triggered when sorting posts.
    
     * app_id - Type: guid.
     *
     * app_site_id - Type: guid. Desc: app site id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: memeber id
     *
     * biToken - Type: guid. Desc: msid
     *
     * sort_by - Type: string. Desc: newest, oldest, number of comments, number of views or number of likes
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid.
     * @param {forumPostsSortParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumPostsSort = function (params) {
        return this.bi.log(__assign({ evid: 563 }, params));
    };
    /**
    * @typedef {Object} actionButtonRemoveModeratorPopupConfirmationClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} post_id - post_id guid
    * @property {string} type - post, comment
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: action button -> remove moderator popup confirmation click. Evid: 580.
     * Event description: Event triggered when clicking confirm in the popup.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post_id guid
     *
     * type - Type: string. Desc: post, comment
     *
     * visitor_id - Type: guid.
     * @param {actionButtonRemoveModeratorPopupConfirmationClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.actionButtonRemoveModeratorPopupConfirmationClick = function (params) {
        return this.bi.log(__assign({ evid: 580 }, params));
    };
    /**
    * @typedef {Object} profilePageEditProfileClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: profile page -> edit profile click. Evid: 538.
     * Event description: Event triggered when clicking on edit profile button.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {profilePageEditProfileClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.profilePageEditProfileClick = function (params) {
        return this.bi.log(__assign({ evid: 538 }, params));
    };
    /**
    * @typedef {Object} postIsReportedWixAppParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - null
    * @property {GUID} instance_id - null
    * @property {string} member_id - null
    * @property {GUID} msid - msid
    * @property {GUID} biToken - null
    * @property {GUID} owner_id - post owner id
    * @property {GUID} post_id - reported post id
    * @property {string} type - 'spam'/'violence'/'harassment'/'nudity or sexual activity'/'other'
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Post is reported - Wix App. Evid: 570.
     * Event description: Event triggered when the post is reported in Wix App.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid.
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * biToken - Type: guid.
     *
     * owner_id - Type: guid. Desc: post owner id
     *
     * post_id - Type: guid. Desc: reported post id
     *
     * type - Type: string. Desc: 'spam'/'violence'/'harassment'/'nudity or sexual activity'/'other'
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid.
     * @param {postIsReportedWixAppParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postIsReportedWixApp = function (params) {
        return this.bi.log(__assign({ evid: 570 }, params));
    };
    /**
    * @typedef {Object} postDeletedParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {boolean} is_admin - 0 - not the admin / 1 - the admin
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} post_id - post_id guid
    * @property {string} type - post, comment
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: post deleted. Evid: 555.
     * Event description: Event triggered after post is deleted.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * is_admin - Type: bool. Desc: 0 - not the admin / 1 - the admin
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post_id guid
     *
     * type - Type: string. Desc: post, comment
     *
     * visitor_id - Type: guid.
     * @param {postDeletedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postDeleted = function (params) {
        return this.bi.log(__assign({ evid: 555 }, params));
    };
    /**
    * @typedef {Object} actionButtonSharePopupCancelClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - feed_page, post_page, search_results, user_profile
    * @property {string} post_id - post_id guid
    * @property {string} type - post, comment
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: action button -> share popup cancel click. Evid: 531.
     * Event description: Event triggered when clicking x on the share popup.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: feed_page, post_page, search_results, user_profile
     *
     * post_id - Type: string. Desc: post_id guid
     *
     * type - Type: string. Desc: post, comment
     *
     * visitor_id - Type: guid.
     * @param {actionButtonSharePopupCancelClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.actionButtonSharePopupCancelClick = function (params) {
        return this.bi.log(__assign({ evid: 531 }, params));
    };
    /**
    * @typedef {Object} postPublishedParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {string} application_id - Unused
    * @property {string} applicationType - OneApp / Web
    * @property {string} application_type - OneApp / Web
    * @property {boolean} category_changed - 0 - didnt change category / 1 - did change category
    * @property {number} file_count - Number of files attached to a post
    * @property {boolean} has_emoji - 0 - no emoji / 1 - with emoji
    * @property {boolean} has_gallery - false - no gallery, true - with gallery
    * @property {boolean} has_hashtag - 0 - no hashtag / 1 - has hashtag
    * @property {boolean} has_image - 0 - no image / 1 - with image
    * @property {boolean} has_mention - 0 - no mention / 1 - with mention
    * @property {boolean} has_quote - 0 - no quote / 1 - with quote
    * @property {boolean} has_video - 0 - no video/ 1 - with video
    * @property {number} hashtag_count - the number of hashtags in post
    * @property {number} image_count - the number of images in the post
    * @property {number} image_in_gallery_count - the number of images in gallery
    * @property {GUID} instance_id - null
    * @property {boolean} is_admin - 0 - not the admin / 1 - the admin
    * @property {boolean} is_edited - 0 - new post / 1 - edit (to know if its posted for first time)
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {number} mention_count - the number of mentions in post
    * @property {GUID} biToken - null
    * @property {string} origin - Unused
    * @property {string} post_id - post_id guid
    * @property {string} type - post, comment, reply, general
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: post published. Evid: 523.
     * Event description: Event triggered after post is published.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * application_id - Type: string. Desc: Unused
     *
     * applicationType - Type: string. Desc: OneApp / Web
     *
     * application_type - Type: string. Desc: OneApp / Web
     *
     * category_changed - Type: bool. Desc: 0 - didnt change category / 1 - did change category
     *
     * file_count - Type: numeric. Desc: Number of files attached to a post
     *
     * has_emoji - Type: bool. Desc: 0 - no emoji / 1 - with emoji
     *
     * has_gallery - Type: bool. Desc: false - no gallery, true - with gallery
     *
     * has_hashtag - Type: bool. Desc: 0 - no hashtag / 1 - has hashtag
     *
     * has_image - Type: bool. Desc: 0 - no image / 1 - with image
     *
     * has_mention - Type: bool. Desc: 0 - no mention / 1 - with mention
     *
     * has_quote - Type: bool. Desc: 0 - no quote / 1 - with quote
     *
     * has_video - Type: bool. Desc: 0 - no video/ 1 - with video
     *
     * hashtag_count - Type: numeric. Desc: the number of hashtags in post
     *
     * image_count - Type: numeric. Desc: the number of images in the post
     *
     * image_in_gallery_count - Type: numeric. Desc: the number of images in gallery
     *
     * instance_id - Type: guid.
     *
     * is_admin - Type: bool. Desc: 0 - not the admin / 1 - the admin
     *
     * is_edited - Type: bool. Desc: 0 - new post / 1 - edit (to know if its posted for first time)
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * mention_count - Type: numeric. Desc: the number of mentions in post
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: Unused
     *
     * post_id - Type: string. Desc: post_id guid
     *
     * type - Type: string. Desc: post, comment, reply, general
     *
     * visitor_id - Type: guid.
     * @param {postPublishedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postPublished = function (params) {
        return this.bi.log(__assign({ evid: 523 }, params));
    };
    /**
    * @typedef {Object} profilePageProfilePageOpenedParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - log_in_bar_widget, external_link (url, google), breadcrumbs, feed_page, search_results, post_page
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: profile page -> profile page opened. Evid: 537.
     * Event description: Event triggered when profile page opened.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: log_in_bar_widget, external_link (url, google), breadcrumbs, feed_page, search_results, post_page
     *
     * visitor_id - Type: guid.
     * @param {profilePageProfilePageOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.profilePageProfilePageOpened = function (params) {
        return this.bi.log(__assign({ evid: 537 }, params));
    };
    /**
    * @typedef {Object} editingPostWindowCancelPostClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: editing post window -> cancel post click. Evid: 507.
     * Event description: event triggered when a user click on cancel in the post edit window. event is also relevant for new posts! not just edit.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {editingPostWindowCancelPostClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editingPostWindowCancelPostClick = function (params) {
        return this.bi.log(__assign({ evid: 507 }, params));
    };
    /**
    * @typedef {Object} membersPageSearchResultsParams
    * @property {GUID} app_id - null
    * @property {GUID} app_site_id - null
    * @property {GUID} instance_id - null
    * @property {string} member_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - categories_page, feed_page, post_page, user_settings, user_profile, notifications, search_results
    * @property {string} referral_info - direct
    * @property {number} result_count_members - int
    * @property {string} search_term - what the user typed
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: members page -> search results. Evid: 559.
     * Event description: Event triggered when searching in the members page.
    
     * app_id - Type: guid.
     *
     * app_site_id - Type: guid.
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: categories_page, feed_page, post_page, user_settings, user_profile, notifications, search_results
     *
     * referral_info - Type: string. Desc: direct
     *
     * result_count_members - Type: numeric. Desc: int
     *
     * search_term - Type: string. Desc: what the user typed
     *
     * visitor_id - Type: guid.
     * @param {membersPageSearchResultsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.membersPageSearchResults = function (params) {
        return this.bi.log(__assign({ evid: 559 }, params));
    };
    /**
    * @typedef {Object} goToProfileClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {string} bar_location - login_bar, breadcrumbs
    * @property {GUID} instance_id - null
    * @property {boolean} is_my_profile - 1 - is own profile , 0 - not
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - feed_page, post_page, search_results
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: go to profile click. Evid: 513.
     * Event description: Event triggered when clicking on avatar.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * bar_location - Type: string. Desc: login_bar, breadcrumbs
     *
     * instance_id - Type: guid.
     *
     * is_my_profile - Type: bool. Desc: 1 - is own profile , 0 - not
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: feed_page, post_page, search_results
     *
     * visitor_id - Type: guid.
     * @param {goToProfileClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.goToProfileClick = function (params) {
        return this.bi.log(__assign({ evid: 513 }, params));
    };
    /**
    * @typedef {Object} editUserUsernameChangedParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: edit user -> username changed. Evid: 542.
     * Event description: Event triggered after changing username.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {editUserUsernameChangedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editUserUsernameChanged = function (params) {
        return this.bi.log(__assign({ evid: 542 }, params));
    };
    /**
    * @typedef {Object} actionButtonMoveCategoryPopupCancelClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} post_id - post_id guid
    * @property {string} type - post, comment
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: action button -> move category popup cancel click. Evid: 534.
     * Event description: Event triggered when clicking cancel on the move to popup.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post_id guid
     *
     * type - Type: string. Desc: post, comment
     *
     * visitor_id - Type: guid.
     * @param {actionButtonMoveCategoryPopupCancelClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.actionButtonMoveCategoryPopupCancelClick = function (params) {
        return this.bi.log(__assign({ evid: 534 }, params));
    };
    /**
    * @typedef {Object} archiveEventNotInUse520Params
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - categories_page, feed_page, post_page, user_settings, user_profile, notifications, search_results, null
    * @property {GUID} original_instance_id - original_instance_id
    * @property {string} trigger - login_bar_widget, create_new_post, comment_login, follow_user, category_for_members_only
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: archive event - not in use. Evid: 520.
     * Event description: archive event - not in use.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: categories_page, feed_page, post_page, user_settings, user_profile, notifications, search_results, null
     *
     * original_instance_id - Type: guid. Desc: original_instance_id
     *
     * trigger - Type: string. Desc: login_bar_widget, create_new_post, comment_login, follow_user, category_for_members_only
     *
     * visitor_id - Type: guid.
     * @param {archiveEventNotInUse520Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.archiveEventNotInUse520 = function (params) {
        return this.bi.log(__assign({ evid: 520 }, params));
    };
    /**
    * @typedef {Object} membersPageMembersPageOpenedParams
    * @property {GUID} app_id - null
    * @property {GUID} app_site_id - null
    * @property {GUID} instance_id - null
    * @property {string} member_id - null
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: members page -> members page opened. Evid: 558.
     * Event description: Event triggered when the members page opened.
    
     * app_id - Type: guid.
     *
     * app_site_id - Type: guid.
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string.
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {membersPageMembersPageOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.membersPageMembersPageOpened = function (params) {
        return this.bi.log(__assign({ evid: 558 }, params));
    };
    /**
    * @typedef {Object} actionButtonReportPopupConfirmationClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} post_id - post_id guid
    * @property {string} report_reason - inappropirate_lang, offensive_media, spam
    * @property {string} type - post, comment
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: action button -> report popup confirmation click. Evid: 529.
     * Event description: Event triggered when clicking report on the report popup.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post_id guid
     *
     * report_reason - Type: string. Desc: inappropirate_lang, offensive_media, spam
     *
     * type - Type: string. Desc: post, comment
     *
     * visitor_id - Type: guid.
     * @param {actionButtonReportPopupConfirmationClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.actionButtonReportPopupConfirmationClick = function (params) {
        return this.bi.log(__assign({ evid: 529 }, params));
    };
    /**
    * @typedef {Object} editUserCoverPhotoChangeClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: edit user -> cover photo change click. Evid: 557.
     * Event description: Event triggered after clicking on changing cover image. this is the 'try' event of 541.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {editUserCoverPhotoChangeClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editUserCoverPhotoChangeClick = function (params) {
        return this.bi.log(__assign({ evid: 557 }, params));
    };
    /**
    * @typedef {Object} followPostClickWixAppParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} msid - msid
    * @property {GUID} biToken - null
    * @property {GUID} owner_id - post owner id
    * @property {string} post_followed - the post_id that had been followed
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Follow post click - Wix App. Evid: 569.
     * Event description: Event triggered when clicking on follow post button in Wix App.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * msid - Type: guid. Desc: msid
     *
     * biToken - Type: guid.
     *
     * owner_id - Type: guid. Desc: post owner id
     *
     * post_followed - Type: string. Desc: the post_id that had been followed
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid.
     * @param {followPostClickWixAppParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.followPostClickWixApp = function (params) {
        return this.bi.log(__assign({ evid: 569 }, params));
    };
    /**
    * @typedef {Object} actionButtonReportPopupCancelClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} post_id - post_id guid
    * @property {string} type - post, comment
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: action button -> report popup cancel click. Evid: 533.
     * Event description: Event triggered when clicking cancel on the report popup.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post_id guid
     *
     * type - Type: string. Desc: post, comment
     *
     * visitor_id - Type: guid.
     * @param {actionButtonReportPopupCancelClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.actionButtonReportPopupCancelClick = function (params) {
        return this.bi.log(__assign({ evid: 533 }, params));
    };
    /**
    * @typedef {Object} postPageOpenedParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - feed_page, post_edit_page, categories_page, search_results, create_post, post_page
    * @property {string} post_id - post_id guid
    * @property {string} post_slug - post_slug
    * @property {string} post_title - post_slug
    * @property {string} search_term - null if didnt come from search
    * @property {string} type - post, comment
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: post page opened. Evid: 517.
     * Event description: Event triggered when post opened.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: feed_page, post_edit_page, categories_page, search_results, create_post, post_page
     *
     * post_id - Type: string. Desc: post_id guid
     *
     * post_slug - Type: string. Desc: post_slug
     *
     * post_title - Type: string. Desc: post_slug
     *
     * search_term - Type: string. Desc: null if didnt come from search
     *
     * type - Type: string. Desc: post, comment
     *
     * visitor_id - Type: guid.
     * @param {postPageOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postPageOpened = function (params) {
        return this.bi.log(__assign({ evid: 517 }, params));
    };
    /**
    * @typedef {Object} membersPageSortParams
    * @property {GUID} app_id - null
    * @property {GUID} app_site_id - null
    * @property {GUID} instance_id - null
    * @property {string} member_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - feed_page, user_profile
    * @property {string} sort_by - (role, num of posts, etc')
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: members page -> sort. Evid: 560.
     * Event description: Event triggered when sorting posts.
    
     * app_id - Type: guid.
     *
     * app_site_id - Type: guid.
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: feed_page, user_profile
     *
     * sort_by - Type: string. Desc: (role, num of posts, etc')
     *
     * visitor_id - Type: guid.
     * @param {membersPageSortParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.membersPageSort = function (params) {
        return this.bi.log(__assign({ evid: 560 }, params));
    };
    /**
    * @typedef {Object} actionButtonActionClickParams
    * @property {string} action - (pin, edit, delete, lock, move_category, share, report, follow_post, block_user, settings, logout, top comment)
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {string} comment_id - Comment id
    * @property {GUID} comment_owner_id - Comment owner guid
    * @property {boolean} flag - 0 - unpin, unlock, unfollow / 1 - pin, lock, follow (for pin / lock / follow post - for other will be null)
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} name - action_click (added because dev sends it)
    * @property {string} origin - feed_page, post_page, search_results, user_profile
    * @property {string} post_id - post_id guid (only from post / comment. if not from post send null)
    * @property {string} type - post, comment (only from post / comment. if not from post send null)
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: action button -> action click. Evid: 526.
     * Event description: Event triggered when clicking on one of the actions.
    
     * action - Type: string. Desc: (pin, edit, delete, lock, move_category, share, report, follow_post, block_user, settings, logout, top comment)
     *
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * comment_id - Type: string. Desc: Comment id
     *
     * comment_owner_id - Type: guid. Desc: Comment owner guid
     *
     * flag - Type: bool. Desc: 0 - unpin, unlock, unfollow / 1 - pin, lock, follow (for pin / lock / follow post - for other will be null)
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * name - Type: string. Desc: action_click (added because dev sends it)
     *
     * origin - Type: string. Desc: feed_page, post_page, search_results, user_profile
     *
     * post_id - Type: string. Desc: post_id guid (only from post / comment. if not from post send null)
     *
     * type - Type: string. Desc: post, comment (only from post / comment. if not from post send null)
     *
     * visitor_id - Type: guid.
     * @param {actionButtonActionClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.actionButtonActionClick = function (params) {
        return this.bi.log(__assign({ evid: 526 }, params));
    };
    /**
    * @typedef {Object} archiveEventNotInUse522Params
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} post_id - post_id
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: archive event - not in use. Evid: 522.
     * Event description: archive event - not in use.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post_id
     *
     * visitor_id - Type: guid.
     * @param {archiveEventNotInUse522Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.archiveEventNotInUse522 = function (params) {
        return this.bi.log(__assign({ evid: 522 }, params));
    };
    /**
    * @typedef {Object} searchPageSearchTabClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} tab_name - posts, members
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: search page -> search tab click. Evid: 536.
     * Event description: Event triggered when clicking on tabs in search.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * tab_name - Type: string. Desc: posts, members
     *
     * visitor_id - Type: guid.
     * @param {searchPageSearchTabClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.searchPageSearchTabClick = function (params) {
        return this.bi.log(__assign({ evid: 536 }, params));
    };
    /**
    * @typedef {Object} actionButtonPopupShareConfirmClickParams
    * @property {GUID} app_id - null
    * @property {GUID} app_site_id - null
    * @property {GUID} instance_id - null
    * @property {string} location - popup, post buttom
    * @property {string} member_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - null
    * @property {string} post_id - null
    * @property {string} share_destination - null
    * @property {string} type - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: action button -> popup share confirm click. Evid: 527.
     * Event description: Event triggered when clicking on one of the 4 options on share popup.
    
     * app_id - Type: guid.
     *
     * app_site_id - Type: guid.
     *
     * instance_id - Type: guid.
     *
     * location - Type: string. Desc: popup, post buttom
     *
     * member_id - Type: string.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string.
     *
     * post_id - Type: string.
     *
     * share_destination - Type: string.
     *
     * type - Type: string.
     *
     * visitor_id - Type: guid.
     * @param {actionButtonPopupShareConfirmClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.actionButtonPopupShareConfirmClick = function (params) {
        return this.bi.log(__assign({ evid: 527 }, params));
    };
    /**
    * @typedef {Object} notificationPageNotificationClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} notification_type - like, comment, follow
    * @property {string} post_id - post_id guid (will be null for follow notification)
    * @property {string} type - post, comment
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: notification page -> notification click. Evid: 544.
     * Event description: Event triggered when a user clicking on notification.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * notification_type - Type: string. Desc: like, comment, follow
     *
     * post_id - Type: string. Desc: post_id guid (will be null for follow notification)
     *
     * type - Type: string. Desc: post, comment
     *
     * visitor_id - Type: guid.
     * @param {notificationPageNotificationClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.notificationPageNotificationClick = function (params) {
        return this.bi.log(__assign({ evid: 544 }, params));
    };
    /**
    * @typedef {Object} followMemberClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {boolean} flag - 0 - not follow / 1 - follow
    * @property {GUID} instance_id - null
    * @property {string} member_followed - the member_id that had been followed
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - search_results, user_profile
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: follow member click. Evid: 515.
     * Event description: Event triggered when clicking on follow button.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * flag - Type: bool. Desc: 0 - not follow / 1 - follow
     *
     * instance_id - Type: guid.
     *
     * member_followed - Type: string. Desc: the member_id that had been followed
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: search_results, user_profile
     *
     * visitor_id - Type: guid.
     * @param {followMemberClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.followMemberClick = function (params) {
        return this.bi.log(__assign({ evid: 515 }, params));
    };
    /**
    * @typedef {Object} breadcrumbsClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {string} current_page_type - feed_page, post_page, user_settings, user_profile, notifications, search_results
    * @property {string} destination_page_type - categories_page, feed_page, user_profile
    * @property {number} from_position - int (position of the current page in the breadcrumbs)
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {number} to_position - int (position of the destination page in the breadcrumbs)
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: breadcrumbs click. Evid: 512.
     * Event description: Event triggered when clicking on breadcrumbs.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * current_page_type - Type: string. Desc: feed_page, post_page, user_settings, user_profile, notifications, search_results
     *
     * destination_page_type - Type: string. Desc: categories_page, feed_page, user_profile
     *
     * from_position - Type: numeric. Desc: int (position of the current page in the breadcrumbs)
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * to_position - Type: numeric. Desc: int (position of the destination page in the breadcrumbs)
     *
     * visitor_id - Type: guid.
     * @param {breadcrumbsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.breadcrumbsClick = function (params) {
        return this.bi.log(__assign({ evid: 512 }, params));
    };
    /**
    * @typedef {Object} appFullyLoadedParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    * @property {GUID} vsi - vsi
    **/
    /**
     * Name: App fully loaded. Evid: 704.
     * Event description: This is 4th step out of 4, in the Forum success rate flow:
    1. Server gets request (101)
    2. Server finished processing request and sends to user (102)
    3. User gets the html (103)
    4. App fully loaded (704).
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     *
     * vsi - Type: guid. Desc: vsi
     * @param {appFullyLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.appFullyLoaded = function (params) {
        return this.bi.log(__assign({ evid: 704 }, params));
    };
    /**
    * @typedef {Object} forumSettingsSelectLanguageParams
    * @property {GUID} app_id - null
    * @property {GUID} app_site_id - null
    * @property {GUID} instance_id - null
    * @property {string} language - Selected language
    * @property {string} member_id - null
    * @property {GUID} biToken - null
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Forum settings: select language. Evid: 564.
     * Event description: Event trigger when selecting a language in language settings.
    
     * app_id - Type: guid.
     *
     * app_site_id - Type: guid.
     *
     * instance_id - Type: guid.
     *
     * language - Type: string. Desc: Selected language
     *
     * member_id - Type: string.
     *
     * biToken - Type: guid.
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid.
     * @param {forumSettingsSelectLanguageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsSelectLanguage = function (params) {
        return this.bi.log(__assign({ evid: 564 }, params));
    };
    /**
    * @typedef {Object} fileDownloadedParams
    * @property {GUID} app_id - app id
    * @property {GUID} app_site_id - app site id
    * @property {string} application_type - Web / OneApp
    * @property {string} file_ext - File extension
    * @property {string} file_id - The file identifier
    * @property {number} file_size - The size of the file being downloaded (in bytes)
    * @property {GUID} instance_id - instance id
    * @property {string} member_id - member id
    * @property {string} mime_type - File type
    * @property {GUID} biToken - metasite id
    * @property {boolean} success - 0 - no download link / 1 - download link received
    * @property {string} type - post, comment, reply, general
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - visitor id
    **/
    /**
     * Name: file downloaded. Evid: 572.
     * Event description: Event triggered when a person tries to download a file from a forum post, comment or reply..
    
     * app_id - Type: guid. Desc: app id
     *
     * app_site_id - Type: guid. Desc: app site id
     *
     * application_type - Type: string. Desc: Web / OneApp
     *
     * file_ext - Type: string. Desc: File extension
     *
     * file_id - Type: string. Desc: The file identifier
     *
     * file_size - Type: numeric. Desc: The size of the file being downloaded (in bytes)
     *
     * instance_id - Type: guid. Desc: instance id
     *
     * member_id - Type: string. Desc: member id
     *
     * mime_type - Type: string. Desc: File type
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * success - Type: bool. Desc: 0 - no download link / 1 - download link received
     *
     * type - Type: string. Desc: post, comment, reply, general
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid. Desc: visitor id
     * @param {fileDownloadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.fileDownloaded = function (params) {
        return this.bi.log(__assign({ evid: 572 }, params));
    };
    /**
    * @typedef {Object} actionButtonDeletePopupConfirmationClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} post_id - post_id guid
    * @property {string} type - post, comment
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: action button -> delete popup confirmation click. Evid: 528.
     * Event description: Event triggered when clicking delete on the delete popup.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post_id guid
     *
     * type - Type: string. Desc: post, comment
     *
     * visitor_id - Type: guid.
     * @param {actionButtonDeletePopupConfirmationClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.actionButtonDeletePopupConfirmationClick = function (params) {
        return this.bi.log(__assign({ evid: 528 }, params));
    };
    /**
    * @typedef {Object} mentionsSuggestionsListOpenedParams
    * @property {GUID} app_id - app id
    * @property {GUID} app_site_id - app site id
    * @property {string} application_type - Web/OneApp
    * @property {GUID} instance_id - instance id
    * @property {string} list_source - keyboard or button
    * @property {string} member_id - member id
    * @property {GUID} biToken - msid
    * @property {string} type - comment/ reply/post
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - visitor id
    **/
    /**
     * Name: mentions suggestions list opened. Evid: 574.
     * Event description: When a user added '@' from top bar or from keyboard and the suggestions list opened.
    
     * app_id - Type: guid. Desc: app id
     *
     * app_site_id - Type: guid. Desc: app site id
     *
     * application_type - Type: string. Desc: Web/OneApp
     *
     * instance_id - Type: guid. Desc: instance id
     *
     * list_source - Type: string. Desc: keyboard or button
     *
     * member_id - Type: string. Desc: member id
     *
     * biToken - Type: guid. Desc: msid
     *
     * type - Type: string. Desc: comment/ reply/post
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid. Desc: visitor id
     * @param {mentionsSuggestionsListOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mentionsSuggestionsListOpened = function (params) {
        return this.bi.log(__assign({ evid: 574 }, params));
    };
    /**
    * @typedef {Object} clickOnCategoryParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {string} category_id - category_id guid
    * @property {string} category_slug - category_slug
    * @property {string} catgory_name - catgory_slug
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - categories_page, dropdown (dropdown is for mobile)
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: click on category. Evid: 502.
     * Event description: Event triggered when category is clicked.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * category_id - Type: string. Desc: category_id guid
     *
     * category_slug - Type: string. Desc: category_slug
     *
     * catgory_name - Type: string. Desc: catgory_slug
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: categories_page, dropdown (dropdown is for mobile)
     *
     * visitor_id - Type: guid.
     * @param {clickOnCategoryParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnCategory = function (params) {
        return this.bi.log(__assign({ evid: 502 }, params));
    };
    /**
    * @typedef {Object} mainPageOpenedParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - wix_site, external_link (url, google), breadcrumbs, list_icon (list_icon is from mobile only (hamburger icon))
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: main page opened. Evid: 501.
     * Event description: Event triggered when categories (main) page opened.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: wix_site, external_link (url, google), breadcrumbs, list_icon (list_icon is from mobile only (hamburger icon))
     *
     * visitor_id - Type: guid.
     * @param {mainPageOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mainPageOpened = function (params) {
        return this.bi.log(__assign({ evid: 501 }, params));
    };
    /**
    * @typedef {Object} actionButtonDeletePopupCancelClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} post_id - post_id guid
    * @property {string} type - post, comment
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: action button -> delete popup cancel click. Evid: 532.
     * Event description: Event triggered when clicking cancel on the delete popup.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post_id guid
     *
     * type - Type: string. Desc: post, comment
     *
     * visitor_id - Type: guid.
     * @param {actionButtonDeletePopupCancelClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.actionButtonDeletePopupCancelClick = function (params) {
        return this.bi.log(__assign({ evid: 532 }, params));
    };
    /**
    * @typedef {Object} followCategoryClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {string} category_followed - the category_id that had been followed
    * @property {boolean} flag - 0 - not follow / 1 - follow
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - search_results, user_profile
    * @property {string} type - 'follow' /'following'/'unfollow'
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: follow/unfollow category success. Evid: 554.
     * Event description: Event triggered when clicking on follow category button.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * category_followed - Type: string. Desc: the category_id that had been followed
     *
     * flag - Type: bool. Desc: 0 - not follow / 1 - follow
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: search_results, user_profile
     *
     * type - Type: string. Desc: 'follow' /'following'/'unfollow'
     *
     * visitor_id - Type: guid.
     * @param {followCategoryClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.followCategoryClick = function (params) {
        return this.bi.log(__assign({ evid: 554 }, params));
    };
    /**
    * @typedef {Object} editingPostWindowPublishPostClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: editing post window -> publish post click. Evid: 508.
     * Event description: event triggered when a user click on publish in the post edit window. event is also relevant for new posts! not just edit.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {editingPostWindowPublishPostClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editingPostWindowPublishPostClick = function (params) {
        return this.bi.log(__assign({ evid: 508 }, params));
    };
    /**
    * @typedef {Object} archiveEventNotInUse549Params
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {string} bar_location - login_bar, breadcrumbs
    * @property {GUID} instance_id - null
    * @property {string} member_id - member_id
    * @property {GUID} biToken - null
    * @property {number} num_of_notification_bubble - int (the number of notification on the notification bubble once you clicked on it)
    * @property {string} origin - categories_page, feed_page, post_page, user_settings, user_profile, notifications, search_results
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: archive event - not in use. Evid: 549.
     * Event description: archive event - not in use.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * bar_location - Type: string. Desc: login_bar, breadcrumbs
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: member_id
     *
     * biToken - Type: guid.
     *
     * num_of_notification_bubble - Type: numeric. Desc: int (the number of notification on the notification bubble once you clicked on it)
     *
     * origin - Type: string. Desc: categories_page, feed_page, post_page, user_settings, user_profile, notifications, search_results
     *
     * visitor_id - Type: guid.
     * @param {archiveEventNotInUse549Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.archiveEventNotInUse549 = function (params) {
        return this.bi.log(__assign({ evid: 549 }, params));
    };
    /**
    * @typedef {Object} settingsPageSettingsClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {boolean} flag - 0 - off / 1 - on
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} settings_type - (Email_likes, email_comments, email_subscriptions, push_likes, push_comments, push_subscriptions)
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: settings page -> settings click. Evid: 546.
     * Event description: Event trigger when changing the toggles.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * flag - Type: bool. Desc: 0 - off / 1 - on
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * settings_type - Type: string. Desc: (Email_likes, email_comments, email_subscriptions, push_likes, push_comments, push_subscriptions)
     *
     * visitor_id - Type: guid.
     * @param {settingsPageSettingsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.settingsPageSettingsClick = function (params) {
        return this.bi.log(__assign({ evid: 546 }, params));
    };
    /**
    * @typedef {Object} notificationPageNotificationPageOpenedParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: notification page -> notification page opened. Evid: 543.
     * Event description: Event triggered when the notification page opens.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {notificationPageNotificationPageOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.notificationPageNotificationPageOpened = function (params) {
        return this.bi.log(__assign({ evid: 543 }, params));
    };
    /**
    * @typedef {Object} actionButtonAddModeratorPopupCancelClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} post_id - post_id guid
    * @property {string} type - post, comment
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: action button -> add moderator popup cancel click. Evid: 583.
     * Event description: Event triggered when clicking confirm in the popup.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post_id guid
     *
     * type - Type: string. Desc: post, comment
     *
     * visitor_id - Type: guid.
     * @param {actionButtonAddModeratorPopupCancelClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.actionButtonAddModeratorPopupCancelClick = function (params) {
        return this.bi.log(__assign({ evid: 583 }, params));
    };
    /**
    * @typedef {Object} editUserCoverPhotoChangedParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: edit user -> cover photo changed. Evid: 541.
     * Event description: Event triggered after changing cover image.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {editUserCoverPhotoChangedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editUserCoverPhotoChanged = function (params) {
        return this.bi.log(__assign({ evid: 541 }, params));
    };
    /**
    * @typedef {Object} feedPageOpenedParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {string} category_id - category_id guid
    * @property {string} category_name - category_slug
    * @property {string} category_slug - category_slug
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - categories_page, external_link (url, google), breadcrumbs, wix_site
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: feed page opened. Evid: 503.
     * Event description: Event triggered when feed page opened.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * category_id - Type: string. Desc: category_id guid
     *
     * category_name - Type: string. Desc: category_slug
     *
     * category_slug - Type: string. Desc: category_slug
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: categories_page, external_link (url, google), breadcrumbs, wix_site
     *
     * visitor_id - Type: guid.
     * @param {feedPageOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.feedPageOpened = function (params) {
        return this.bi.log(__assign({ evid: 503 }, params));
    };
    /**
    * @typedef {Object} actionButtonAddModeratorPopupConfirmationClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} post_id - post_id guid
    * @property {string} type - post, comment
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: action button -> add moderator popup confirmation click. Evid: 582.
     * Event description: Event triggered when clicking confirm in the popup.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post_id guid
     *
     * type - Type: string. Desc: post, comment
     *
     * visitor_id - Type: guid.
     * @param {actionButtonAddModeratorPopupConfirmationClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.actionButtonAddModeratorPopupConfirmationClick = function (params) {
        return this.bi.log(__assign({ evid: 582 }, params));
    };
    /**
    * @typedef {Object} sortClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - feed_page, user_profile
    * @property {string} sort_by - (views, comments, loves, date, null for cards)
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: sort click. Evid: 504.
     * Event description: Event triggered when sorting posts.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: feed_page, user_profile
     *
     * sort_by - Type: string. Desc: (views, comments, loves, date, null for cards)
     *
     * visitor_id - Type: guid.
     * @param {sortClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.sortClick = function (params) {
        return this.bi.log(__assign({ evid: 504 }, params));
    };
    /**
    * @typedef {Object} likeClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {boolean} flag - 0 - unliked / 1 - like
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - feed_page, post_page, search_results, user_profile
    * @property {string} post_id - post_id guid
    * @property {string} type - post, comment
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: like click. Evid: 521.
     * Event description: Event triggered after clicking on like.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * flag - Type: bool. Desc: 0 - unliked / 1 - like
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: feed_page, post_page, search_results, user_profile
     *
     * post_id - Type: string. Desc: post_id guid
     *
     * type - Type: string. Desc: post, comment
     *
     * visitor_id - Type: guid.
     * @param {likeClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.likeClick = function (params) {
        return this.bi.log(__assign({ evid: 521 }, params));
    };
    /**
    * @typedef {Object} archiveEventNotInUse550Params
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {boolean} is_moderator - 0 - not moderator / 1 - moderator
    * @property {string} login_method - email, facebook, google
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: archive event - not in use. Evid: 550.
     * Event description: archive event - not in use.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * is_moderator - Type: bool. Desc: 0 - not moderator / 1 - moderator
     *
     * login_method - Type: string. Desc: email, facebook, google
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {archiveEventNotInUse550Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.archiveEventNotInUse550 = function (params) {
        return this.bi.log(__assign({ evid: 550 }, params));
    };
    /**
    * @typedef {Object} editingPostWindowTextEditorOpenedParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} type - post, comment
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: editing post window -> text editor opened. Evid: 509.
     * Event description: Event triggered when text editor opens (post & comment text editing toolbar). event is also relevant for new posts! not just edit.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: post, comment
     *
     * visitor_id - Type: guid.
     * @param {editingPostWindowTextEditorOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editingPostWindowTextEditorOpened = function (params) {
        return this.bi.log(__assign({ evid: 509 }, params));
    };
    /**
    * @typedef {Object} createPostClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {string} button_position - top, bottom - (bottom only for classic)
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: create post click. Evid: 505.
     * Event description: Event triggered when clicking on create new post button.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * button_position - Type: string. Desc: top, bottom - (bottom only for classic)
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {createPostClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.createPostClick = function (params) {
        return this.bi.log(__assign({ evid: 505 }, params));
    };
    /**
    * @typedef {Object} actionButtonLogInSignUpParams
    * @property {GUID} app_id - null
    * @property {GUID} app_site_id - null
    * @property {GUID} instance_id - null
    * @property {string} member_id - null
    * @property {GUID} biToken - null
    * @property {string} type - login/signup
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: log in / sign up to comment. Evid: 568.
     * Event description: Event triggered when clicking on sign up or login in in post page.
    
     * app_id - Type: guid.
     *
     * app_site_id - Type: guid.
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string.
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: login/signup
     *
     * visitor_id - Type: guid.
     * @param {actionButtonLogInSignUpParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.actionButtonLogInSignUp = function (params) {
        return this.bi.log(__assign({ evid: 568 }, params));
    };
    /**
    * @typedef {Object} followersPageOpenedParams
    * @property {GUID} app_id - null
    * @property {GUID} app_site_id - null
    * @property {GUID} instance_id - null
    * @property {string} member_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - feed_page, user_profile
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: followers page opened. Evid: 561.
     * Event description: Event triggered when followers page is opened.
    
     * app_id - Type: guid.
     *
     * app_site_id - Type: guid.
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: feed_page, user_profile
     *
     * visitor_id - Type: guid.
     * @param {followersPageOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.followersPageOpened = function (params) {
        return this.bi.log(__assign({ evid: 561 }, params));
    };
    /**
    * @typedef {Object} actionButtonOpenActionsParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - feed_page, inner_page, search, user_profile
    * @property {string} post_id - post_id guid (only from post / comment. if not from post send null)
    * @property {string} type - post, comment (only from post / comment. if not from post send null)
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: action button -> open actions. Evid: 524.
     * Event description: Event triggered after you click on 3 dots.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: feed_page, inner_page, search, user_profile
     *
     * post_id - Type: string. Desc: post_id guid (only from post / comment. if not from post send null)
     *
     * type - Type: string. Desc: post, comment (only from post / comment. if not from post send null)
     *
     * visitor_id - Type: guid.
     * @param {actionButtonOpenActionsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.actionButtonOpenActions = function (params) {
        return this.bi.log(__assign({ evid: 524 }, params));
    };
    /**
    * @typedef {Object} editPostImageFinishUploadingParams
    * @property {GUID} app_id - null
    * @property {GUID} app_site_id - null
    * @property {GUID} instance_id - null
    * @property {string} member_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - image type - cover, avatar, post editor
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: edit post -> Image finish uploading. Evid: 552.
     * Event description: event triggered when a user finish to upload Image (comes together with Image start uploading for success rate).
    
     * app_id - Type: guid.
     *
     * app_site_id - Type: guid.
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: image type - cover, avatar, post editor
     *
     * visitor_id - Type: guid.
     * @param {editPostImageFinishUploadingParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editPostImageFinishUploading = function (params) {
        return this.bi.log(__assign({ evid: 552 }, params));
    };
    /**
    * @typedef {Object} settingsPageSettingsPageOpenedParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: settings page -> settings page opened. Evid: 545.
     * Event description: Event trigger when setting page opens.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {settingsPageSettingsPageOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.settingsPageSettingsPageOpened = function (params) {
        return this.bi.log(__assign({ evid: 545 }, params));
    };
    /**
    * @typedef {Object} followingPageOpenedParams
    * @property {GUID} app_id - null
    * @property {GUID} app_site_id - null
    * @property {GUID} instance_id - null
    * @property {string} member_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - feed_page, user_profile
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: following page opened. Evid: 562.
     * Event description: Event triggered when following page is opened.
    
     * app_id - Type: guid.
     *
     * app_site_id - Type: guid.
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: feed_page, user_profile
     *
     * visitor_id - Type: guid.
     * @param {followingPageOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.followingPageOpened = function (params) {
        return this.bi.log(__assign({ evid: 562 }, params));
    };
    /**
    * @typedef {Object} editUserEditProfilePageOpenedParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: edit user -> edit profile page opened. Evid: 539.
     * Event description: Event triggered when edit profile page opened.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {editUserEditProfilePageOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editUserEditProfilePageOpened = function (params) {
        return this.bi.log(__assign({ evid: 539 }, params));
    };
    /**
    * @typedef {Object} editUserAvatarChangeClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: edit user -> avatar change click. Evid: 556.
     * Event description: Event triggered after clicking on changing avatar. this is the 'try' event of 540..
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {editUserAvatarChangeClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editUserAvatarChangeClick = function (params) {
        return this.bi.log(__assign({ evid: 556 }, params));
    };
    /**
    * @typedef {Object} searchPageSearchPageOpenedParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: search page -> search page opened. Evid: 535.
     * Event description: Event triggered when the search page opens.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {searchPageSearchPageOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.searchPageSearchPageOpened = function (params) {
        return this.bi.log(__assign({ evid: 535 }, params));
    };
    /**
    * @typedef {Object} clickOnPostCommentParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - feed_page, search
    * @property {string} post_id - post_id guid
    * @property {string} post_slug - post_slug
    * @property {string} post_title - post_slug
    * @property {string} search_term - null if didnt come from search
    * @property {string} type - post, comment
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: click on post comment. Evid: 518.
     * Event description: Event triggered when clicking on comments icon from feed page, or on a comment from search results.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: feed_page, search
     *
     * post_id - Type: string. Desc: post_id guid
     *
     * post_slug - Type: string. Desc: post_slug
     *
     * post_title - Type: string. Desc: post_slug
     *
     * search_term - Type: string. Desc: null if didnt come from search
     *
     * type - Type: string. Desc: post, comment
     *
     * visitor_id - Type: guid.
     * @param {clickOnPostCommentParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnPostComment = function (params) {
        return this.bi.log(__assign({ evid: 518 }, params));
    };
    /**
    * @typedef {Object} editPostPostEditingWindowOpenedParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: edit post -> post editing window opened. Evid: 506.
     * Event description: event triggered when user start creating a new post.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {editPostPostEditingWindowOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editPostPostEditingWindowOpened = function (params) {
        return this.bi.log(__assign({ evid: 506 }, params));
    };
    /**
    * @typedef {Object} postLimitReachedParams
    * @property {GUID} app_id - app id
    * @property {GUID} app_site_id - app site id
    * @property {string} application_type - Web / OneApp
    * @property {GUID} instance_id - instance id
    * @property {string} member_id - member id
    * @property {GUID} biToken - metasite id
    * @property {number} post_limit - post limit set by the site owner (1, 5, 10)
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - visitor id
    **/
    /**
     * Name: post limit reached. Evid: 576.
     * Event description: If a limit option is set by the site owner, event is triggered when a new member (registered for no longer than a week) tries post in a forum after reaching the limit.
    
     * app_id - Type: guid. Desc: app id
     *
     * app_site_id - Type: guid. Desc: app site id
     *
     * application_type - Type: string. Desc: Web / OneApp
     *
     * instance_id - Type: guid. Desc: instance id
     *
     * member_id - Type: string. Desc: member id
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * post_limit - Type: numeric. Desc: post limit set by the site owner (1, 5, 10)
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid. Desc: visitor id
     * @param {postLimitReachedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postLimitReached = function (params) {
        return this.bi.log(__assign({ evid: 576 }, params));
    };
    /**
    * @typedef {Object} actionButtonRemoveModeratorPopupCancelClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} post_id - post_id guid
    * @property {string} type - post, comment
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: action button -> remove moderator popup cancel click. Evid: 581.
     * Event description: Event triggered when clicking cancel in the popup.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post_id guid
     *
     * type - Type: string. Desc: post, comment
     *
     * visitor_id - Type: guid.
     * @param {actionButtonRemoveModeratorPopupCancelClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.actionButtonRemoveModeratorPopupCancelClick = function (params) {
        return this.bi.log(__assign({ evid: 581 }, params));
    };
    /**
    * @typedef {Object} actionButtonCloseActionsParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - feed_page, inner_page, search, user_profile
    * @property {string} post_id - post_id guid (only from post / comment. if not from post send null)
    * @property {string} type - post, comment (only from post / comment. if not from post send null)
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: action button -> close actions. Evid: 525.
     * Event description: Event triggered after you close the actions popup.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: feed_page, inner_page, search, user_profile
     *
     * post_id - Type: string. Desc: post_id guid (only from post / comment. if not from post send null)
     *
     * type - Type: string. Desc: post, comment (only from post / comment. if not from post send null)
     *
     * visitor_id - Type: guid.
     * @param {actionButtonCloseActionsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.actionButtonCloseActions = function (params) {
        return this.bi.log(__assign({ evid: 525 }, params));
    };
    /**
    * @typedef {Object} searchFocusParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - categories_page, feed_page, post_page, user_settings, user_profile, notifications, search_results
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: search focus. Evid: 510.
     * Event description: Event triggered when focusing on search.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: categories_page, feed_page, post_page, user_settings, user_profile, notifications, search_results
     *
     * visitor_id - Type: guid.
     * @param {searchFocusParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.searchFocus = function (params) {
        return this.bi.log(__assign({ evid: 510 }, params));
    };
    /**
    * @typedef {Object} paginationClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {string} button_type - button_type
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - feed_page, search
    * @property {string} page_destination - (1,2...,previous,next) - string
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: pagination click. Evid: 519.
     * Event description: Event triggered when you click on pagination (move between pages - numbers, back, forward).
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * button_type - Type: string. Desc: button_type
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: feed_page, search
     *
     * page_destination - Type: string. Desc: (1,2...,previous,next) - string
     *
     * visitor_id - Type: guid.
     * @param {paginationClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.paginationClick = function (params) {
        return this.bi.log(__assign({ evid: 519 }, params));
    };
    /**
    * @typedef {Object} mentionSuggestionsMemberSelectedParams
    * @property {GUID} app_id - app id
    * @property {GUID} app_site_id - app site id
    * @property {string} application_type - Web/OneApp
    * @property {GUID} instance_id - instance id
    * @property {string} member_id - member id
    * @property {GUID} biToken - msid
    * @property {string} type - comment/ reply/post
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - visitor id
    **/
    /**
     * Name: mention suggestions member selected. Evid: 575.
     * Event description: When a user clicks one user from the mentioned list.
    
     * app_id - Type: guid. Desc: app id
     *
     * app_site_id - Type: guid. Desc: app site id
     *
     * application_type - Type: string. Desc: Web/OneApp
     *
     * instance_id - Type: guid. Desc: instance id
     *
     * member_id - Type: string. Desc: member id
     *
     * biToken - Type: guid. Desc: msid
     *
     * type - Type: string. Desc: comment/ reply/post
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid. Desc: visitor id
     * @param {mentionSuggestionsMemberSelectedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mentionSuggestionsMemberSelected = function (params) {
        return this.bi.log(__assign({ evid: 575 }, params));
    };
    /**
    * @typedef {Object} fileUploadedParams
    * @property {GUID} app_id - app id
    * @property {GUID} app_site_id - app site id
    * @property {string} application_type - Web / OneApp
    * @property {string} file_ext - File extension
    * @property {string} file_id - The file identifier (null if not successful)
    * @property {number} file_size - The size of the file being uploaded (in bytes)
    * @property {GUID} instance_id - instance id
    * @property {string} member_id - member id
    * @property {string} mime_type - File type
    * @property {GUID} biToken - metasite id
    * @property {boolean} success - 0 - upload failed / 1 - upload successful
    * @property {string} type - post, comment, reply, general
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - visitor id
    **/
    /**
     * Name: file uploaded. Evid: 571.
     * Event description: Event triggered when a person tries to upload a file to a forum post, comment or reply (Only files within the size limit trigger the event).
    
     * app_id - Type: guid. Desc: app id
     *
     * app_site_id - Type: guid. Desc: app site id
     *
     * application_type - Type: string. Desc: Web / OneApp
     *
     * file_ext - Type: string. Desc: File extension
     *
     * file_id - Type: string. Desc: The file identifier (null if not successful)
     *
     * file_size - Type: numeric. Desc: The size of the file being uploaded (in bytes)
     *
     * instance_id - Type: guid. Desc: instance id
     *
     * member_id - Type: string. Desc: member id
     *
     * mime_type - Type: string. Desc: File type
     *
     * biToken - Type: guid. Desc: metasite id
     *
     * success - Type: bool. Desc: 0 - upload failed / 1 - upload successful
     *
     * type - Type: string. Desc: post, comment, reply, general
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid. Desc: visitor id
     * @param {fileUploadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.fileUploaded = function (params) {
        return this.bi.log(__assign({ evid: 571 }, params));
    };
    /**
    * @typedef {Object} followPostClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {boolean} flag - 0 - not follow / 1 - follow
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - search_results, user_profile
    * @property {string} post_followed - the post_id that had been followed
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: follow post click. Evid: 553.
     * Event description: Event triggered when clicking on follow post button.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * flag - Type: bool. Desc: 0 - not follow / 1 - follow
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: search_results, user_profile
     *
     * post_followed - Type: string. Desc: the post_id that had been followed
     *
     * visitor_id - Type: guid.
     * @param {followPostClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.followPostClick = function (params) {
        return this.bi.log(__assign({ evid: 553 }, params));
    };
    /**
    * @typedef {Object} searchResultsParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - categories_page, feed_page, post_page, user_settings, user_profile, notifications, search_results
    * @property {string} referral_info - direct
    * @property {number} result_count_members - int
    * @property {number} result_count_posts - int
    * @property {string} search_term - what the user typed
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: search results. Evid: 511.
     * Event description: Event triggered when moving to search results page.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: categories_page, feed_page, post_page, user_settings, user_profile, notifications, search_results
     *
     * referral_info - Type: string. Desc: direct
     *
     * result_count_members - Type: numeric. Desc: int
     *
     * result_count_posts - Type: numeric. Desc: int
     *
     * search_term - Type: string. Desc: what the user typed
     *
     * visitor_id - Type: guid.
     * @param {searchResultsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.searchResults = function (params) {
        return this.bi.log(__assign({ evid: 511 }, params));
    };
    /**
    * @typedef {Object} actionButtonMoveCategoryPopupConfirmationClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} post_id - post_id guid
    * @property {string} type - post, comment
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: action button -> move category popup confirmation click. Evid: 530.
     * Event description: Event triggered when clicking move on move to popup.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * post_id - Type: string. Desc: post_id guid
     *
     * type - Type: string. Desc: post, comment
     *
     * visitor_id - Type: guid.
     * @param {actionButtonMoveCategoryPopupConfirmationClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.actionButtonMoveCategoryPopupConfirmationClick = function (params) {
        return this.bi.log(__assign({ evid: 530 }, params));
    };
    /**
    * @typedef {Object} forumSettingsCustomizePostToolbarParams
    * @property {GUID} app_id - null
    * @property {GUID} app_site_id - null
    * @property {string} feature - image/gallery/video/divider/HTML/emoji
    * @property {GUID} instance_id - null
    * @property {string} member_id - null
    * @property {GUID} biToken - null
    * @property {string} type - on/off
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Forum settings: customize post toolbar. Evid: 565.
     * Event description: Event triggered after switching toggl.
    
     * app_id - Type: guid.
     *
     * app_site_id - Type: guid.
     *
     * feature - Type: string. Desc: image/gallery/video/divider/HTML/emoji
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string.
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: on/off
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid.
     * @param {forumSettingsCustomizePostToolbarParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forumSettingsCustomizePostToolbar = function (params) {
        return this.bi.log(__assign({ evid: 565 }, params));
    };
    /**
    * @typedef {Object} moveCategoryUpDownParams
    * @property {GUID} app_id - null
    * @property {GUID} app_site_id - null
    * @property {string} applicationType - OneApp / Web
    * @property {string} category_id - category id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {GUID} subcategory_id - subcategory id
    * @property {string} type - post, comment
    * @property {string} type_chosen - down/up
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: move category up/down. Evid: 567.
     * Event description: Event triggered when clicking move category down/up.
    
     * app_id - Type: guid.
     *
     * app_site_id - Type: guid.
     *
     * applicationType - Type: string. Desc: OneApp / Web
     *
     * category_id - Type: string. Desc: category id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * subcategory_id - Type: guid. Desc: subcategory id
     *
     * type - Type: string. Desc: post, comment
     *
     * type_chosen - Type: string. Desc: down/up
     *
     * visitor_id - Type: guid.
     * @param {moveCategoryUpDownParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.moveCategoryUpDown = function (params) {
        return this.bi.log(__assign({ evid: 567 }, params));
    };
    /**
    * @typedef {Object} archiveEventNotInUse514Params
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - login_bar_widget, feed_page, post_page, search_results
    * @property {GUID} original_instance_id - original_instance_id
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: archive event - not in use. Evid: 514.
     * Event description: archive event - not in use.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: login_bar_widget, feed_page, post_page, search_results
     *
     * original_instance_id - Type: guid. Desc: original_instance_id
     *
     * visitor_id - Type: guid.
     * @param {archiveEventNotInUse514Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.archiveEventNotInUse514 = function (params) {
        return this.bi.log(__assign({ evid: 514 }, params));
    };
    /**
    * @typedef {Object} clickOnPostParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - feed_page, post_edit_page, categories_page, search_results, create_post, post_page
    * @property {string} post_id - post_id guid
    * @property {string} post_name - post_slug
    * @property {string} post_slug - post_slug
    * @property {string} search_term - null if didnt come from search
    * @property {string} type - post, comment, undefined
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: click on post. Evid: 516.
     * Event description: Event triggered when clicking on a post.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: feed_page, post_edit_page, categories_page, search_results, create_post, post_page
     *
     * post_id - Type: string. Desc: post_id guid
     *
     * post_name - Type: string. Desc: post_slug
     *
     * post_slug - Type: string. Desc: post_slug
     *
     * search_term - Type: string. Desc: null if didnt come from search
     *
     * type - Type: string. Desc: post, comment, undefined
     *
     * visitor_id - Type: guid.
     * @param {clickOnPostParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnPost = function (params) {
        return this.bi.log(__assign({ evid: 516 }, params));
    };
    /**
    * @typedef {Object} mobileBackToCategoriesMenuClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: mobile -> back to categories menu click. Evid: 548.
     * Event description: Event trigger when clicking back on the hamburger icon.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {mobileBackToCategoriesMenuClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mobileBackToCategoriesMenuClick = function (params) {
        return this.bi.log(__assign({ evid: 548 }, params));
    };
    /**
    * @typedef {Object} editUserAvatarChangedParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: edit user -> avatar changed. Evid: 540.
     * Event description: Event triggered after changing avatar.
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * visitor_id - Type: guid.
     * @param {editUserAvatarChangedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.editUserAvatarChanged = function (params) {
        return this.bi.log(__assign({ evid: 540 }, params));
    };
    /**
    * @typedef {Object} postSortInCategoryParams
    * @property {GUID} app_id - null
    * @property {GUID} app_site_id - app_site_id
    * @property {string} application_type - OneApp / Web
    * @property {string} category_id - category id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - posts_page / search
    * @property {string} sort_by - recent activity / newest / most comments / most viewed / most liked
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: post sort. Evid: 566.
     * Event description: Event triggered when sorting posts in category.
    
     * app_id - Type: guid.
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * application_type - Type: string. Desc: OneApp / Web
     *
     * category_id - Type: string. Desc: category id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: posts_page / search
     *
     * sort_by - Type: string. Desc: recent activity / newest / most comments / most viewed / most liked
     *
     * visitor_id - Type: guid.
     * @param {postSortInCategoryParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postSortInCategory = function (params) {
        return this.bi.log(__assign({ evid: 566 }, params));
    };
    /**
    * @typedef {Object} mobileBackToSiteClickParams
    * @property {GUID} app_id - app_id
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {string} member_id - the member_id after login to Wix forum
    * @property {GUID} biToken - null
    * @property {string} origin - categories_page, feed_page
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: mobile -> back to site click. Evid: 547.
     * Event description: Event trigger when clicking on the home icon (mobile).
    
     * app_id - Type: guid. Desc: app_id
     *
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * member_id - Type: string. Desc: the member_id after login to Wix forum
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: categories_page, feed_page
     *
     * visitor_id - Type: guid.
     * @param {mobileBackToSiteClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mobileBackToSiteClick = function (params) {
        return this.bi.log(__assign({ evid: 547 }, params));
    };
    /**
    * @typedef {Object} mentionClickedFromPsotParams
    * @property {GUID} app_id - app id
    * @property {GUID} app_site_id - app site id
    * @property {string} application_type - Web/OneApp
    * @property {GUID} instance_id - instance id
    * @property {string} member_id - member id
    * @property {GUID} biToken - msid
    * @property {string} type - comment/ reply/post
    * @property {GUID} uuid - uuid
    * @property {GUID} visitor_id - visitor id
    **/
    /**
     * Name: mention clicked from published post. Evid: 573.
     * Event description: When a user clicks on a mention from published post/comment/reply.
    
     * app_id - Type: guid. Desc: app id
     *
     * app_site_id - Type: guid. Desc: app site id
     *
     * application_type - Type: string. Desc: Web/OneApp
     *
     * instance_id - Type: guid. Desc: instance id
     *
     * member_id - Type: string. Desc: member id
     *
     * biToken - Type: guid. Desc: msid
     *
     * type - Type: string. Desc: comment/ reply/post
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid. Desc: visitor id
     * @param {mentionClickedFromPsotParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mentionClickedFromPsot = function (params) {
        return this.bi.log(__assign({ evid: 573 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
//# sourceMappingURL=index.js.map